module.exports = __webpack_public_path__ + "img/224.c9d9676f.png";